import { apiRequest } from '../Api';

export interface LogoutResponse {
  success: boolean;
  message?: string;
}

export async function logout() {
  const response = await apiRequest<never, LogoutResponse>({
    url: '/auth/logout',
    method: 'POST',
    backend: 'landing',
  });

  return response.data;
}


